import { AxiosResponse } from "axios";
import LoginService from "pages/login/login.service";
import { axiosRequest } from "../../axios/axios.config";
import { ConfiguracaoPedidoBalcaoTO } from "./topBar.model";

const TopBarService = () => {
    const path = '/configuracoes/pedidobalcao';
    const loginService = LoginService();

    return {
        getConfiguracao(): Promise<AxiosResponse<ConfiguracaoPedidoBalcaoTO>> {
            return axiosRequest.get(`${path}`, { headers: loginService.getHeaders() });
        },
        setConfiguracao(configuracao: ConfiguracaoPedidoBalcaoTO): Promise<AxiosResponse<ConfiguracaoPedidoBalcaoTO>> {
            return axiosRequest.put(`${path}`, configuracao, { headers: loginService.getHeaders() });
        },
    };
};

export default TopBarService;
